export default function BookmarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        d="M3 0.875C1.82639 0.875 0.875 1.8264 0.875 3V16.5C0.875 16.7305 1.00187 16.9423 1.20509 17.051C1.40649 17.1588 1.65049 17.1481 1.84153 17.0234L7 14.2429L12.1585 17.0234C12.3495 17.1481 12.5935 17.1588 12.7949 17.051C12.9981 16.9423 13.125 16.7305 13.125 16.5V3C13.125 1.82639 12.1736 0.875 11 0.875H3ZM2.125 3C2.125 2.51675 2.51675 2.125 3 2.125H11C11.4832 2.125 11.875 2.51675 11.875 3V15.3588L7.34095 12.9762C7.1337 12.8413 6.8663 12.8413 6.65905 12.9762L2.125 15.3588V3Z"
        fill="#6C757D"
        stroke="#6C757D"
        strokeWidth="0.25"
      />
    </svg>
  );
}
